import React from "react";
import ReactMarkdown from "react-markdown";
import { MessageBubble } from "@twilio/flex-webchat-ui";
import { MessageBubbleButtons } from "./MessageBubbleButtons";
import nl2br from "react-nl2br";
import { AttachmentMessage } from "./AttachmentMessage";

export class CustomMessageBubble extends MessageBubble {
  state = {
    bodyProps: {}
  };

  componentDidMount() {
    const bodyPropsReceived = this._getBodyProps();
    this.setState({ bodyProps: bodyPropsReceived });
  }

  render() {
    const { message, channelSid } = this.props;

    const renderbodyProps = this._getBodyProps();
    return (
      <div className='Twilio Twilio-MessageBubble'>
        <div className='Twilio-MessageBubble-default'>
          <div className='Twilio-MessageBubble-Header'>
            <div className='Twilio-MessageBubble-UserName'>
              {message.isFromMe ? "" : 'Flapper'}
            </div>
          </div>
          <div className='Twilio-MessageBubble-Body' {...renderbodyProps} />
          <MessageBubbleButtons
            manager={this.props.manager}
            channelSid={channelSid}
            message={message}
          />
        </div>
        <div className='Twilio-MessageBubble-end'>
          <div className='Twilio-MessageBubble-Time'>
            {message.source.timestamp.toLocaleTimeString("pt-BR", {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </div>
        </div>
      </div>
    );
  }

  _getBodyProps = () => {
    const { message } = this.props;
    const { media } = message.source;
    const bodyProps = {
      children: message.source.body,
      props: message
    };

    if (media) {
      bodyProps.children = <AttachmentMessage {...this.props} />;
    } else {
      if (!message.isFromMe) {
        let { body } = message.source;

        if (
          /(\{button:[^}]*\})/g.test(body) ||
          /(\{input:hidden\})/g.test(body)
        ) {
          /* if (
            document &&
            document.querySelector(".Twilio-MessageInput-default")
          )
            document
              .querySelector(".Twilio-MessageInput-default")
              .getElementsByTagName("textarea")[0].style.display = "none"; */
        } else {
          if (
            document &&
            document.querySelector(".Twilio-MessageInput-default")
          )
            document
              .querySelector(".Twilio-MessageInput-default")
              .getElementsByTagName("textarea")[0].style.display = "flex";
        }
        body = body.replace(/(\{button:[^}]*\})/g, "");
        body = body.replace(/(\{input:hidden\})/g, "");
        body = [body.trim()];
        body = this._renderMarkdown(body);
        bodyProps.children = body;
      } else {
        bodyProps.children = nl2br(bodyProps.children);
      }
    }

    return bodyProps;
  };

  _renderMarkdown = (value) => {
    return value.map((item, index) => {
      if (typeof item === "string") {
        return (
          <ReactMarkdown key={index} linkTarget='_blank'>
            {item}
          </ReactMarkdown>
        );
      }
      return item;
    });
  };
}
